import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { UserSettings } from 'shared/models/user-settings.model';
import { SettingsService } from 'shared/services/settings.service';
import { SnackbarService } from 'shared/services/snackbar.service';

export const ManagementGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const snackbar = inject(SnackbarService);

    return inject(SettingsService).getUserSettings().pipe(
        switchMap((userSettings: UserSettings) =>
        {
            if (!userSettings?.user) {
                return of(router.createUrlTree(['/login']));
            }

            if (userSettings.user.role === 'employee' && (!userSettings.user.permissions || !userSettings.user.permissions.includes('VIEW_MANAGEMENT'))) {
                snackbar.showSnackBar('You do not have permission to access this resource.', 'error');
                return of(router.createUrlTree(['/account/home']));
            }

            return of(true);
        }),
    );
};
